// Stream authenticated pages; optional business profiles never gate the booking list.
export async function loadRatingBookings({ fetchPage, onPage, isActive = () => true }) {
  let cursor;
  const seen = new Set();
  const rows = new Map();
  do {
    const response = await fetchPage({
      view: 'history', period: 'all', sort: 'desc', statusFilter: 'all',
      pageSize: 25, parallelLegacy: true, ...(cursor ? { cursor } : {}),
    });
    if (!isActive()) return;
    const data = response?.data || response;
    if (!data?.ok || !Array.isArray(data.bookings)) throw new Error('No pudimos cargar tus servicios. Intenta nuevamente.');
    for (const row of data.bookings) {
      if (row.viewerOwned !== true) continue;
      rows.set(row.path || row._path || `${row.businessId}/${row.id}`, {
        ...row, ...row.ratingDetails,
        status: row.ratingDetails?.status || row.status,
      });
    }
    onPage([...rows.values()]);
    if (data.pageInfo?.degraded) throw new Error('No pudimos consultar todos tus servicios. Intenta nuevamente.');
    if (!data.pageInfo?.hasMore) return [...rows.values()];
    cursor = data.pageInfo.nextCursor;
    const key = JSON.stringify(cursor);
    if (!cursor || seen.has(key)) throw new Error('No pudimos completar la carga. Intenta nuevamente.');
    seen.add(key);
  } while (isActive());
}
